module.exports = __webpack_public_path__ + "static/container-1-f81010dd49f963febd7dbbc43972f788.jpg";